import React, { Component } from 'react';

import {
  eightyPercentLine,
  getTokenData,
  referenceLine,
  twentyPercentLine,
} from '../graphConstants';
import language from '../../../../../assets/languages/language';
import FD from '../../../../RestAPI/fetchData';
import { canvasjsConfig } from '../../../../../common/constant';
import { showFailure } from '../../../../../common/toast';
import App_data from '../../../../config/App_data';
import OverallGraph from './OverallGraph';
import AppRoutes from '../../../../config/AppRoutes';

export default class OverallCanvasGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPointsOverAllGraph: [],
    };
    this.isPathway = this.props.location.pathname.includes(AppRoutes.CFA3_PATHWAY_CBT);

  }
  componentDidMount() {
    const tokenData = getTokenData();
    this.setState(tokenData);
    const {
      id = 0,
      test_id = 0,
      totalQuestions,
      timer = 0,
      isNegative,
    } = this.props.params;
    const data = {
      ...tokenData,
      mock_id: parseInt(id, 10),
      test_id: parseInt(test_id, 10),
      totalQuestion: parseInt(totalQuestions, 10),
      timer: parseInt(timer, 10),
      isNegative: isNegative,
    };
    this.getGraphoverAllGraphData(data);
  }

  getGraphoverAllGraphData = (data) => {
    FD.callAPI(
      `${App_data.backend_api}/${this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams'}/getCBTMockUserGraph`,
      data,
    ).then(async (res) => {
      if (res.graphData) {
        const { totalQuestions } = this.props.params;
        const { averageScore = 0 } = res.graphData;
        this.setState({
          //   isLoading: false,
          totalQuestions,
          average: averageScore,
        });
        this.formatoverAllGraphData(res);
      } else showFailure(res.message);
    });
  };

  //format data as requirement for overall graph
  formatoverAllGraphData = (res) => {
    let { graphData } = res;

    this.setState({
      dataOfCurrentUser: graphData
        ? graphData.dataOfCurrentUser.score
        : this.state.dataOfCurrentUser,
      dataOfEightyPercentileUser: graphData
        ? graphData.dataOfEightyPercentileUser.score
        : this.state.dataOfEightyPercentileUser,
      dataOfTwentyPercentileUser: graphData
        ? graphData.dataOfTwentyPercentileUser.score
        : this.state.dataOfTwentyPercentileUser,
    });
    const { totalMarks } = this.props.params;
    let temp = [graphData];
    graphData = temp;

    //User score line
    let UserScoreOverAllGraph = {
      showInLegend: false,
      name: `${language.LC().GRAPHSCORE}`,

      type: 'line',
      color: '#1f8ceb',
      markerType: 'none',
      dataPoints: [],
      overlayBars: true,
    };
    //User score box

    let scorePercentage =
      graphData[0].dataOfCurrentUser.score == null
        ? 0
        : Math.ceil((graphData[0].dataOfCurrentUser.score / totalMarks) * 100);

    let UserScoreBoxOverAllGraph2 = {
      type: 'rangeColumn',

      color: 'hsl(200deg 67% 88%)',
      dataPoints: [],
    };

    UserScoreBoxOverAllGraph2.dataPoints.push({
      x: 1.39,

      y: [scorePercentage - 5, scorePercentage + 5],
    });

    let dataOfCurrentUserLineStart = {
      x: -0.2,

      y: scorePercentage,
    };
    let dataOfCurrentUserLineMid = {
      x: 2.8,

      y: scorePercentage,
    };
    let dataOfCurrentUserLineEnd = {
      x: 2.8,
      y: null,
    };

    UserScoreOverAllGraph.dataPoints.push(
      dataOfCurrentUserLineStart,
      dataOfCurrentUserLineMid,
      dataOfCurrentUserLineEnd
    );

    let dataOfTwentyPercentileUserlineStart = {
      x: -3,

      y:
        graphData[0].dataOfTwentyPercentileUser.score == null
          ? 0
          : Math.ceil(
              (graphData[0].dataOfTwentyPercentileUser.score / totalMarks) * 100
            ),
    };
    let dataOfTwentyPercentileUserlineMid = {
      x: 7,

      y:
        graphData[0].dataOfTwentyPercentileUser.score == null
          ? 0
          : Math.ceil(
              (graphData[0].dataOfTwentyPercentileUser.score / totalMarks) * 100
            ),
    };
    let dataOfTwentyPercentileUserlineEnd = {
      x: 7,
      y: null,
    };
    const twentyPercentLineObj = { ...twentyPercentLine, dataPoints: [] };

    twentyPercentLineObj.dataPoints.push(
      dataOfTwentyPercentileUserlineStart,
      dataOfTwentyPercentileUserlineMid,
      dataOfTwentyPercentileUserlineEnd
    );
    let dataOfEightyPercentileUserLineStart = {
      x: -3,

      y:
        graphData[0].dataOfEightyPercentileUser.score == null
          ? 0
          : Math.ceil(
              (graphData[0].dataOfEightyPercentileUser.score / totalMarks) * 100
            ),
    };
    let dataOfEightyPercentileUserLineMid = {
      x: 7,

      y:
        graphData[0].dataOfEightyPercentileUser.score == null
          ? 0
          : Math.ceil(
              (graphData[0].dataOfEightyPercentileUser.score / totalMarks) * 100
            ),
    };

    let dataOfEightyPercentileUserLineEnd = {
      x: 7,
      y: null,
    };
    const eightyPercentLineObj = { ...eightyPercentLine, dataPoints: [] };
    eightyPercentLineObj.dataPoints.push(
      dataOfEightyPercentileUserLineStart,
      dataOfEightyPercentileUserLineMid,
      dataOfEightyPercentileUserLineEnd
    );
    const overAllGraphData = [];
    overAllGraphData.push(
      UserScoreBoxOverAllGraph2,
      twentyPercentLineObj,
      eightyPercentLineObj,
      UserScoreOverAllGraph,
      referenceLine
    );

    console.log('overAllGraphData', overAllGraphData);
    this.setState(
      {
        dataPointsOverAllGraph: overAllGraphData,
      },
      () => {
        this.showGraphOverAll(); //Show overall graph
      }
    );
  };

  //Show overall graph
  showGraphOverAll = () => {
    const { dataPointsOverAllGraph } = this.state;

    const chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
      animationEnabled: true,
      axisY: canvasjsConfig.axisY,
      axisX: canvasjsConfig.axisX,

      toolTip: canvasjsConfig.toolTip,
      dataPointWidth: 90,
      dataPointMaxWidth: 80,
      dataPointMinWidth: 80,
      legend: {
        fontSize: 18,
      },
      data: dataPointsOverAllGraph,
      interactivityEnabled: false,
    });
    chart.render();
  };

  render() {
    const {
      average,
      dataOfCurrentUser,
      dataOfEightyPercentileUser,
      dataOfTwentyPercentileUser,
    } = this.state;
    const { totalMarks = 1 } = this.props.params;

    return (
      <OverallGraph
        average={average}
        totalMarks={totalMarks}
        dataOfCurrentUser={dataOfCurrentUser}
        dataOfTwentyPercentileUser={dataOfTwentyPercentileUser}
        dataOfEightyPercentileUser={dataOfEightyPercentileUser}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/ResultGraph/OverallGraph/index.jsx